/* TODO In future fix TS2307 error */
/* eslint-disable @typescript-eslint/ban-ts-comment */

export const importComponentsStyles = (): void => {
    import(
        // @ts-ignore
        /* webpackChunkName: "component-styles" */ '@installments/components/lib/assets/components.css'
    );
};
